import { useEffect, useState } from 'react';

import { useThunkDispatch } from '../../store/use-thunk-dispatch';

/**
 * A way into the webshop carries the arrow: leaving one interface for the
 * other is never to happen unannounced (#2282). Login and company stay the
 * same.
 */
export const shopLink = (label: string): string => `${label} ↗`;

/** Sent when the portal laid articles into the shop's cart, so the count follows (R-159). */
export const SHOP_CART_CHANGED = 'palo:shop-cart-changed';

/** What lies in the webshop's cart, for the way back to it. */
export const useShopCartCount = (): number => {
    const dispatch = useThunkDispatch();
    const [count, setCount] = useState(0);

    useEffect(() => {
        const load = (): void => {
            void dispatch(async (_dispatch, _getState, { api }) => {
                const result = await api.orders.getCartItemCount();
                setCount(result.success ? result.result : 0);
            });
        };

        load();
        window.addEventListener(SHOP_CART_CHANGED, load);

        return () => window.removeEventListener(SHOP_CART_CHANGED, load);
    }, [dispatch]);

    return count;
};
